import { render, staticRenderFns } from "./GroupExerciseOverview.vue?vue&type=template&id=175fcc32&"
import script from "./GroupExerciseOverview.vue?vue&type=script&lang=ts&"
export * from "./GroupExerciseOverview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports